// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__eaJ19","large":"styles_large__3aYPB"};